import axios from '../api';
import store from './../store';
import constants from '../constants';

export default {
  namespaced: true,

  state: {
    displayPreview:true,

    listCvs: [
      /* {
                name:'Titre CV 1',
                accroche: "Velit proident id voluptate veniam nisi commodo consequat ullamco consequat officia ea id labore. Sunt eiusmod non laborum nostrud eu occaecat non amet labore occaecat exercitation qui. Mollit sit sint do proident enim qui cupidatat ullamco id sit. Duis laborum anim excepteur aute dolore elit. Aute laborum irure in qui culpa reprehenderit ut. Nulla cupidatat ipsum culpa qui amet laboris voluptate ad qui.",
                created_at: new Date(),
            },
            {
                name:'Titre CV 2',
                accroche: "Adipisicing laborum est reprehenderit labore pariatur. In ullamco ad velit labore consequat laborum. Nostrud in ea quis incididunt tempor laboris voluptate culpa duis duis reprehenderit in incididunt. Sint ullamco nulla cupidatat ea laboris enim nostrud esse. Incididunt sit mollit ullamco tempor dolor elit sint in aliqua labore proident Lorem ullamco pariatur.",
                created_at: new Date(),
            }, */
    ],
    newerData: [],
    form:{
      name:'',
      description:'',
      last_step:'',
      data:{},
      type: constants.CV_TYPES.BASIC,
    },
    currentStep: '',

    errors:{},

    pdfHeight: 0,

    watermarkHidden: false,

    downloading:false,
  },

  getters: {
    displayPreview(state){
      return state.displayPreview;
    },

    listCvs(state){
      return state.listCvs;
    },

    newerData(state){
      return state.newerData;
    },

    newForm(state){
      return state.newerData[state.form.id];
    },

    form(state){
      return state.form;
    },

    currentStep(state){
      return state.currentStep;
    },



    errors(state){
      return state.errors;
    },

    pdfHeight(state){
      return state.pdfHeight;
    },

    watermarkHidden(state){
      return state.watermarkHidden;
    },

    downloading(state){
      return state.downloading;
    },
  },

  mutations: {
    SET_DISPLAYPREVIEW(state, bool){
      state.displayPreview = bool;
    },

    SET_LISTCVS(state, list){
      state.listCvs = list;
    },

    SET_NEWERDATA(state, list){
      state.newerData = list;
    },

    SET_FORM(state, datas){
      state.form = {...datas};
    },

    SET_CURRENTSTEP(state, step){
      state.currentStep = step;
    },



    SET_ERRORS(state, err){
      state.errors = err;
    },

    SET_PDFHEIGHT(state, height){
      state.pdfHeight = height;
    },

    SET_WATERMARKHIDDEN(state, bool){
      state.watermarkHidden = bool;
    },

    SET_DOWNLOADING(state, bool){
      state.downloading = bool;
    }
  },

  actions: {
    async loadCvs(context){
      await axios.get('api/cv').then(response => {
        context.commit('SET_LISTCVS', response.data[0]);
        context.commit('SET_NEWERDATA', response.data[1]);
      }).catch(err => {
        console.log(err);
      });
    },

    async saveDatas(context){
      context.commit('SET_DISPLAYPREVIEW', false);
      await axios.put('api/cv/'+context.getters.form.id, {form:context.getters.form, currentStep: context.getters.currentStep}).then(response => {
        context.commit('SET_LISTCVS', response.data);
        context.commit('SET_DISPLAYPREVIEW', true);
        store.commit('app/SET_BACKDOOR', store.getters['app/backdoor']+1); //reload computed values
        //context.commit('SET_PDFHEIGHT', document.getElementById("containerVueHtml2PDF").clientHeight);

      }).catch(err => {
        console.log(err);
        context.commit('SET_DISPLAYPREVIEW', true);
        context.commit('SET_ERRORS', err.response.data.errors);
      });
    },

    async removeCV(context, cv){
      await axios.delete('api/cv/'+cv.id).then(() => {

      }).catch(err => {
        console.log(err);
      });
    },

    async dupplicateCV(context, cv){
      await axios.post('api/cv/dupplicate/'+cv.id).then(() => {

      }).catch(err => {
        console.log(err);
      });
    },
  }
};
